module.exports = __webpack_public_path__ + "static/01-MEX-PULQUE.186e99ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/01-MEX-PULQUE.png
// module id = 591
// module chunks = 35783957827783